import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    GraphQLResponse,
    Mk2Request,
    Mk2Response
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import { CompanyFilterInput, Money } from '../../model/models';

export class GetFlexTermAvailabilityRequest extends Mk2Request {
    public refBuyerKeys: string[];
    public buyerAccountKeys: string[];

    constructor(obj?: { refBuyerKeys?: string[]; buyerAccountKeys?: string[] }) {
        super();
        if (obj != null) {
            this.refBuyerKeys =
                typeof obj.refBuyerKeys === 'undefined' ? this.refBuyerKeys : obj.refBuyerKeys;
            this.buyerAccountKeys =
                typeof obj.buyerAccountKeys === 'undefined'
                    ? this.buyerAccountKeys
                    : obj.buyerAccountKeys;
        }
    }
}

export class GetFlexTermAvailabilityResponse extends Mk2Response {
    eligibleAmount?: Money;
    openElegibleFlexTermPayableCount?: number;

    constructor(initial?: Partial<GetFlexTermAvailabilityResponse>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export interface GetFlexTermAvailabilityResponse {
    flexTermAvailability: {
        eligibleInvoiceAmount: Money;
        invoiceCount: number;
    };
}

@Injectable({ providedIn: 'root' })
export class GetFlexTermAvailabilityService extends ApiService<
    GetFlexTermAvailabilityRequest,
    GetFlexTermAvailabilityResponse
> {
    public requestType = GetFlexTermAvailabilityRequest;
    public responseType = GetFlexTermAvailabilityResponse;
    public endpointName = 'v1/query';
    public serviceName = 'financingGql';
    public usePascalForUrl = false;

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }

    public requestMapper(req: GetFlexTermAvailabilityRequest): { query: string } {
        const query = this.mapToGraphQLQuery(req);
        return { query: `{${jsonToGraphQLQuery(query)}}` };
    }

    public responseMapper(
        res: GraphQLResponse<GetFlexTermAvailabilityResponse>
    ): GetFlexTermAvailabilityResponse {
        const { flexTermAvailability } = (res as GraphQLResponse<GetFlexTermAvailabilityResponse>)
            .data;
        return new GetFlexTermAvailabilityResponse({
            eligibleAmount: flexTermAvailability.eligibleInvoiceAmount,
            openElegibleFlexTermPayableCount: flexTermAvailability.invoiceCount
        });
    }

    public get endpointUrl(): string {
        return super.endpointUrl.replace('/api', '');
    }

    private mapToGraphQLQuery(req: GetFlexTermAvailabilityRequest): any {
        const input: Partial<CompanyFilterInput> = {
            buyerIds: req.refBuyerKeys ? req.refBuyerKeys : [],
            buyerAccountIds: req.buyerAccountKeys ? req.buyerAccountKeys : []
        };

        return {
            flexTermAvailability: {
                __args: { companyFilter: input },
                invoiceCount: true,
                eligibleInvoiceAmount: { cents: true, currencyCode: true }
            }
        };
    }
}
